import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormSolutionIcon.tsx
const MedFormSolutionIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "solution-icon.svg",
		alt: t("medicationForm.solution")
	});
};

//#endregion
export { MedFormSolutionIcon };